<template>
  <div>
    <v-layout wrap class="intent-item z-border-red" style="padding: 10px 15px 10px;">
      <v-flex xs12 class="text-xs-right">
        <v-btn @click="$emit('arrayProductRemove')" fab small outline color="primary"
          ><v-icon>delete</v-icon></v-btn
        >
      </v-flex>
      <v-flex xs2>
        <uploadfile
          :height="90"
          :backGroundAuto="true"
          v-model="product.product_image_url"
          data-vv-as="Stock Image"
          @onUploaded="onUploadImage(index, $event)"
        >
          <v-btn flat fab small>
            <v-icon small>camera_alt</v-icon>
          </v-btn>
        </uploadfile>
        <i
          v-if="product.product_image_url"
          class="fa fa-trash middle primary-color"
          style="position: absolute; right: -5px; cursor: pointer; top: 25px; z-index: 2;"
          @click="deletePhoto(index, oindex)"
        ></i>
      </v-flex>

      <v-flex xs10>
        <v-layout wrap>
          <v-flex xs9>
            <div
              class="form-control pa-1"
              :class="{ 'has-error': errors.has(`product_title_${index}`) }"
            >
              <label>{{ $t('products_name') }}*</label>
              <input
                :key="`product_title_${index}`"
                :data-vv-as="$t('products_name')"
                v-model="product.product_title"
                :name="`product_title_${index}`"
                class="form-control mr-3"
                type="text"
                v-validate="'required'"
                maxlength="50"
              />
              <span class="text-error" v-if="errors.has(`product_title_${index}`)">{{
                errors.first(`product_title_${index}`)
              }}</span>
            </div>
          </v-flex>
          <v-flex xs3>
            <div
              class="form-control pa-1"
              :class="{ 'has-error': errors.has(`start_price_${index}`) }"
            >
              <label>{{ $t('Starting price') }}*</label>
              <input
                :key="`start_price_${index}`"
                :data-vv-as="$t('Starting price')"
                v-model="product.start_price"
                :name="`start_price_${index}`"
                class="form-control mr-3"
                type="text"
                v-validate="'required'"
                maxlength="20"
              />
              <span class="text-error" v-if="errors.has(`start_price_${index}`)">{{
                errors.first(`start_price_${index}`)
              }}</span>
            </div>
          </v-flex>
          <v-flex xs6>
            <div class="form-control pa-1" :class="{ 'has-error': errors.has(`keyword_${index}`) }">
              <label>{{ $t('keyword') }}*</label>
              <input
                :key="`keyword_${index}`"
                :data-vv-as="$t('keyword')"
                v-model="product.q_val"
                :name="`keyword_${index}`"
                class="form-control mr-3"
                type="text"
                v-validate="'required'"
                maxlength="50"
              />
              <span class="text-error" v-if="errors.has(`keyword_${index}`)">{{
                errors.first(`keyword_${index}`)
              }}</span>
            </div>
          </v-flex>
          <v-flex xs6>
            <div
              class="form-control pa-1"
              :class="{ 'has-error': errors.has(`minimum_bid_${index}`) }"
            >
              <label>{{ $t('minimum_bid') }}*</label>
              <input
                :key="`minimum_bid_${index}`"
                :data-vv-as="$t('minimum_bid')"
                v-model="product.minimum_bid"
                :name="`minimum_bid_${index}`"
                class="form-control mr-3"
                type="text"
                v-validate="'required'"
                maxlength="20"
              />
              <span class="text-error" v-if="errors.has(`minimum_bid_${index}`)">{{
                errors.first(`minimum_bid_${index}`)
              }}</span>
            </div>
          </v-flex>
          <v-flex xs12 v-if="!allProductToggle">
            <label>{{ $t('set_the_auction_end_time_automatically') }}*</label>
            <v-layout wrap>
              <v-flex
                xs6
                class="form-control"
                :class="{ 'has-error': errors.has(`endDate2_${index}`) }"
              >
                <v-menu
                  :key="`endDate2_${index}`"
                  ref="openEndDate"
                  v-model="openModalDate"
                  :close-on-content-click="false"
                  full-width
                  max-width="290px"
                  color="primary"
                >
                  <template v-slot:activator="{ on }">
                    <input
                      type="text"
                      style="margin: 4px 0px;"
                      :placeholder="$t('date')"
                      readonly
                      :value="endDate"
                      v-on="on"
                      clearable
                      small
                      class="form-control browser-default"
                      :name="`endDate2_${index}`"
                      :data-vv-as="$t('date')"
                    />
                  </template>
                  <v-date-picker
                    :allowed-dates="disablePastDates"
                    color="primary"
                    v-model="endDate"
                    @input="
                      setEndtime()
                      openModalDate = false
                    "
                  ></v-date-picker>
                </v-menu>
                <span class="text-error" v-if="errors.has(`endDate2_${index}`)">{{
                  errors.first(`endDate2_${index}`)
                }}</span>
              </v-flex>

              <v-flex
                xs6
                class="pl-1 form-control"
                :class="{ 'has-error': errors.has(`setEndTime_${index}`) }"
                v-if="!loadTime"
              >
                <time-picker
                  class="mt-1 form-control browser-default"
                  :name="`setEndTime_${index}`"
                  :data-vv-as="$t('time')"
                  :key="`setEndTime_${timestamp}`"
                  v-model="endTime"
                  full-width
                  format="HH:mm"
                  :placeholder="$t('time')"
                  :hide-clear-button="true"
                  @input="setEndtime"
                  v-validate="'required'"
                ></time-picker>
                <span class="text-error" v-if="errors.has(`setEndTime_${index}`)">{{
                  errors.first(`setEndTime_${index}`)
                }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex>
            <div class="my-2">
              <toggle-button
                class="mt-2 mb-2"
                :value="product.schedule_is_active"
                @change="product.schedule_is_active = !product.schedule_is_active"
                :sync="true"
                :color="$vuetify.theme.success"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
              />
              <span class="ml-2"
                >{{ $t('enable_the_latest_bid_updates') }}</span
              >
            </div>
            <v-flex
              xs6
              class="pl-1 form-control"
              :class="{ 'has-error': errors.has(`setLatestBidTime_${index}`) }"
              v-if="!loadTime"
            >
              <time-picker
                class="mt-1 form-control browser-default"
                :name="`setLatestBidTime_${index}`"
                :data-vv-as="$t('time')"
                :key="`setLatestBidTime_${timestamp}`"
                v-model="latestBidTime"
                full-width
                format="HH:mm"
                :placeholder="$t('time')"
                :hide-clear-button="true"
                :minute-interval="5"
                @input="setLatestBidTime"
                v-validate="'required'"
              ></time-picker>
              <span class="text-error" v-if="errors.has(`setLatestBidTime_${index}`)">{{
                errors.first(`setLatestBidTime_${index}`)
              }}</span>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import uploadfile from '@/components/elements/uploadfile'
import TimePicker from '@/components/elements/TimePicker.vue'
import { ToggleButton } from 'vue-js-toggle-button'
import dayjs from 'dayjs'
export default {
  props: {
    value: {
      default: null
    },
    allProductToggle: {
      default: false
    },
    index: {
      default: null
    },
    errorTime: {
      default: false
    }
  },
  components: {
    uploadfile,
    TimePicker,
    ToggleButton
  },
  computed: {},
  data: function() {
    return {
      loadTime: false,
      endDate: null,
      endTime: { HH: '00', mm: '00' },
      latestBidTime: { HH: '00', mm: '00' },
      product: this.value,
      openModalDate: false,
      timestamp: dayjs().format('x')
    }
  },
  mounted() {
    const vm = this
    if (
      vm.product.schedule_notify_max_bid_within_seconds &&
      typeof vm.product.schedule_notify_max_bid_within_seconds !== 'object'
    ) {
      vm.latestBidTime = {
        HH:
          (
            '0' + Math.floor(parseInt(vm.product.schedule_notify_max_bid_within_seconds) / 60 / 60)
          ).slice(-2) || '00',
        mm:
          (
            '0' +
            JSON.stringify((parseInt(vm.product.schedule_notify_max_bid_within_seconds) / 60) % 60)
          ).slice(-2) || '00'
      }
    }
    if (vm.product.end_at) {
      vm.loadTime = true
      vm.endDate = vm.getFormatDate(vm.product.end_at, 'YYYY-MM-DD')
      vm.endTime = {
        HH: vm.getFormatDate(vm.product.end_at, 'HH'),
        mm: vm.getFormatDate(vm.product.end_at, 'mm')
      }
      // vm.setEndtime()
      vm.loadTime = false
    }
    let pointer = null
    let keyword = null
    if (this.product.q_val.startsWith('includes(') && this.product.q_val.endsWith(')')) {
      pointer = this.product.q_val.search(/\(/g)
      keyword = this.product.q_val.substring(pointer + 1, this.product.q_val.length - 1)
      this.product.q_val = keyword
    }
    vm.timestamp = dayjs().format('x')
  },
  inject: ['parentValidator'],
  created() {
    this.$validator = this.parentValidator
  },
  methods: {
    disablePastDates(val) {
      return val >= new Date().toISOString().substr(0, 10)
    },
    setEndtime() {
      const vm = this
      vm.$emit('update:errorTime', false)
      let endDate = dayjs(
        `${vm.endDate || vm.getFormatDate(dayjs(), 'YYYY-MM-DD')} ${
          vm.endTime ? vm.endTime.HH || '00' : '00'
        }:${vm.endTime ? vm.endTime.mm || '00' : '00'}`
      ).format()
      vm.$set(vm.product, 'end_at', endDate)
      vm.$emit('input', vm.product)
    },
    setLatestBidTime() {
      const vm = this
      let latestBidTime = vm.latestBidTime
        ? (parseInt(vm.latestBidTime.HH) * 60 +
            parseInt(
              vm.latestBidTime.mm.substring(0, 1) == 0
                ? vm.latestBidTime.mm.substring(1)
                : vm.latestBidTime.mm
            )) *
          60
        : null
      vm.$set(vm.product, 'schedule_notify_max_bid_within_seconds', latestBidTime)
      vm.$emit('input', vm.product)
    },
    getFormatDate: function(date, format) {
      return dayjs(date).format(format)
    }
  }
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/view/liveAuction/ProductForm.vue